import {ThemingComponent} from './components/theming.component';
import {CustomCssDialogComponent} from './components/custom-css-dialog.component';
import {SettingsThemeService} from './services/settings-theme.service';
import {NAVIGATION} from './settings-theming.navigation';
import {routing} from './settings-theming.routing';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {LayoutService} from '@ngmedax/layout';
import {ColorPickerModule} from 'ngx-color-picker';
import {NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule} from "@angular/forms";
import {CodemirrorModule} from '@ctrl/ngx-codemirror';
import {BrowserModule} from '@angular/platform-browser';


@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    ColorPickerModule,
    NgbTooltipModule,
    NgbModule,
    BrowserModule,
    CodemirrorModule,
    routing,
  ],
  declarations: [
    ThemingComponent,
    CustomCssDialogComponent
  ],
  exports: [],
  providers: [
    SettingsThemeService
  ]
})
export class SettingsThemingModule {
  constructor(private layoutService: LayoutService) {
    this.layoutService.addMenuEntry(NAVIGATION);
  }
}
